define("calendar/templates/application", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="cCA--boardWrapper">
    <div class="cCA--board">
      <Shared::Social::InstagramUpgrade::Banner />
      <Calendar::MultipleBttpUpgradeBanner />
      <Calendar::FullCalendar
        @calendarView={{this.calendarView}}
        @canCreateTimeSlots={{this.canCreateTimeSlots}}
        @canDropOnCalendar={{this.canDropOnCalendar}}
        @closeCalendarSettings={{action "closeCalendarSettings"}}
        @disableDrop={{this.disableDrop}}
        @enablePinterestBusiness={{set this "showPinterestBusiness" true}}
        @notes={{this.calendarNotes}}
        @openEvent={{this.editPost}}
        @posts={{this.calendarPosts}}
        @selectedAssets={{this.selectedMedia}}
        @showAdditionalBanner={{this.isInstagramLogin}}
        @showCalendarSettings={{this.showCalendarSettings}}
        @showQuickScheduleWizard={{action "showQuickScheduleWizard"}}
        @targetDate={{this.targetDate}}
        @timelineStories={{this.timelineStories}}
        @updateTargetDate={{action "updateTargetDate"}}
        @viewCalendarSettings={{action "viewCalendarSettings"}}
      />
    </div>
  </div>
  
  <Shared::PreBoarding />
  
  {{#if this.shouldShowOnboarding}}
    <Calendar::Onboarding::Wizards::Wrapper />
  {{/if}}
  
  {{#if this.showPinterestBusiness}}
    <Shared::PinterestBusiness
      @closeModal={{set this "showPinterestBusiness" false}}
      @socialProfile={{this.singleSocialProfile}}
    />
  {{/if}}
  
  {{outlet}}
  
  {{#if this.showAutoScheduleDropZone}}
    <Calendar::DropZone
      @onDragEnter={{action "onDragEnter"}}
      @onDragLeave={{action "onDragLeave"}}
      @onDrop={{action "onDrop"}}
      @showReleaseText={{this.showReleaseText}}
      @text={{this.dropZoneText}}
    />
  {{/if}}
  */
  {
    "id": "dd4qOLPx",
    "block": "[[[10,0],[14,0,\"cCA--boardWrapper\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"cCA--board\"],[12],[1,\"\\n    \"],[8,[39,0],null,null,null],[1,\"\\n    \"],[8,[39,1],null,null,null],[1,\"\\n    \"],[8,[39,2],null,[[\"@calendarView\",\"@canCreateTimeSlots\",\"@canDropOnCalendar\",\"@closeCalendarSettings\",\"@disableDrop\",\"@enablePinterestBusiness\",\"@notes\",\"@openEvent\",\"@posts\",\"@selectedAssets\",\"@showAdditionalBanner\",\"@showCalendarSettings\",\"@showQuickScheduleWizard\",\"@targetDate\",\"@timelineStories\",\"@updateTargetDate\",\"@viewCalendarSettings\"],[[30,0,[\"calendarView\"]],[30,0,[\"canCreateTimeSlots\"]],[30,0,[\"canDropOnCalendar\"]],[28,[37,3],[[30,0],\"closeCalendarSettings\"],null],[30,0,[\"disableDrop\"]],[28,[37,4],[[30,0],\"showPinterestBusiness\",true],null],[30,0,[\"calendarNotes\"]],[30,0,[\"editPost\"]],[30,0,[\"calendarPosts\"]],[30,0,[\"selectedMedia\"]],[30,0,[\"isInstagramLogin\"]],[30,0,[\"showCalendarSettings\"]],[28,[37,3],[[30,0],\"showQuickScheduleWizard\"],null],[30,0,[\"targetDate\"]],[30,0,[\"timelineStories\"]],[28,[37,3],[[30,0],\"updateTargetDate\"],null],[28,[37,3],[[30,0],\"viewCalendarSettings\"],null]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,5],null,null,null],[1,\"\\n\\n\"],[41,[30,0,[\"shouldShowOnboarding\"]],[[[1,\"  \"],[8,[39,7],null,null,null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showPinterestBusiness\"]],[[[1,\"  \"],[8,[39,8],null,[[\"@closeModal\",\"@socialProfile\"],[[28,[37,4],[[30,0],\"showPinterestBusiness\",false],null],[30,0,[\"singleSocialProfile\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[46,[28,[37,10],null,null],null,null,null],[1,\"\\n\\n\"],[41,[30,0,[\"showAutoScheduleDropZone\"]],[[[1,\"  \"],[8,[39,11],null,[[\"@onDragEnter\",\"@onDragLeave\",\"@onDrop\",\"@showReleaseText\",\"@text\"],[[28,[37,3],[[30,0],\"onDragEnter\"],null],[28,[37,3],[[30,0],\"onDragLeave\"],null],[28,[37,3],[[30,0],\"onDrop\"],null],[30,0,[\"showReleaseText\"]],[30,0,[\"dropZoneText\"]]]],null],[1,\"\\n\"]],[]],null]],[],false,[\"shared/social/instagram-upgrade/banner\",\"calendar/multiple-bttp-upgrade-banner\",\"calendar/full-calendar\",\"action\",\"set\",\"shared/pre-boarding\",\"if\",\"calendar/onboarding/wizards/wrapper\",\"shared/pinterest-business\",\"component\",\"-outlet\",\"calendar/drop-zone\"]]",
    "moduleName": "calendar/templates/application.hbs",
    "isStrictMode": false
  });
});